import React, { useState } from "react";
import Header1 from "../../Components/seperate Components/Header1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPhone } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../Components/Footer";
import "../../Styles/Redirecting Styles/NavbarStyles/Dedicate.css";
import Shape2 from "../../assets/brand/choose-shape-2.png";
// import hireResource from "../../assets/All Images/hire-resource.jpg";
// import hireResource1 from "../../assets/All Images/hire-resource1.jpg";
// import hireResource2 from "../../assets/All Images/hire-resource2.jpg";
// import workTogether from "../../assets/All Images/work-together.jpg";
import board from "../../assets/icons/board.png";
import sandTimer from "../../assets/icons/sand-timer.png";
import report from "../../assets/icons/report.png";
import infrastructure from "../../assets/icons/infrastructure.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";

const DedicatedResource = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
        Hire Dedicated Resources | Skilled Team for Your Projects
        </title>
        <meta
          name="description"
          content="Hire a dedicated resource for your projects. Discover the right talent to expand your team. Explore our expert hiring solutions today."
        />
        <meta
          name="keywords"
          content="Hire a resource, hire dedicated resources, or hire dedicated resources."
        />
      </Helmet>
      <Header1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg6 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#01536E" }}
                >
                  Hire A Resource
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <nav className="breadcrumb-trail breadcrumbs">
                      <p style={{ color: "black" }}>
                        Boost your team's potential – hire a talent from India
                        for top-notch expertise and productivity.
                      </p>
                    </nav>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}
      <section className="bd-about-area">
        <div className="bd-custom-container">
          <div className="bd-about-four-bg  pt-80 pb-0 fix">
            <div className="bd-about-shape-box">
              <img
                className="bd-about-shape bd-about-shape-1"
                src="assets/img/shape/about-shape-3.png"
                alt="shape img not found"
              />
              <img
                className="bd-about-shape bd-about-shape-2"
                src="assets/img/shape/about-shape-4.png"
                alt="shape img not found"
              />
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8  first_dedicate">
                    <div className="bd-choose-img text-end mb-30 z-index top-resp">
                      <div className="row align-items-center custom-mar-15">
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                            <img
                              // src={hireResource2}
                              className="resp-img bordertop-img1"
                              alt="img not found"
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              // src={hireResource1}
                              className="resp-img bordertop-img2"
                              alt="img not found"
                            />
                          </div>
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              // src={hireResource}
                              className="resp-img bordertop-img3"
                              alt="img not found"
                            />
                          </div>
                        </div>
                      </div>
                      <img
                        className="bd-choose-shape bd-choose-shape-2"
                        src={Shape2}
                        alt="shape img not found"
                      />
                      {/* <div className="bd-choose-video-popup">
                                                <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
                                                </div> */}
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 second_dedicated">
                    <div className="bd-about-text bd-about-text-four z-index">
                      <div className="bd-section-title-wrapper">
                        <h2 className="bd-section-title md-pr-50 dedicate-first-tittle">
                          {" "}
                          Save time and accomplish more{" "}
                        </h2>
                        <p className="">
                          Dedicated resources help businesses stay focused and
                          on track, ensuring they don’t fall behind in a
                          competitive market. By engaging dedicated resources,
                          your business can avoid common challenges and move
                          towards success.
                        </p>
                        <p className="">
                          Having dedicated resources helps you stay organized
                          and efficient, leading to faster project turnaround
                          times. With dedicated resources in your business, you
                          can increase profitability and achieve greater
                          success. Some businesses invest in dedicated
                          employees, specific resources, or both, giving them
                          better control over their operations and resource
                          management. This also enables businesses to specialize
                          in key areas and keep their resources well-managed and
                          localized.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="B-4CmrDidvE"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          className="btn btn touch_pop_vid first_pop_video_dedicated"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button> */}
      </section>

      {/* Second Section */}
      <section className="bd-choose-area fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape">
            <div className="row dedicated_first_responsive">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 deicated-first_sec">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title ml-15 second_sec-tittle">
                    Stay focused on what matters with the support of a{" "}
                    <span style={{ color: "#098FB4" }}>Dedicated Team </span>
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p className="ml-25 dedicat-para1">
                      Running a successful business requires dedicated
                      resources. By having a team of experts who specialize in
                      your industry, your business can stay competitive and
                      profitable. With so much information available, it can be
                      overwhelming to know where to begin. That’s why our
                      dedicated resource team is here—to help you make the most
                      of your business.
                    </p>
                  </div>
                  <div></div>
                </div>
                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 deicated-second_sec">
                <div className="bd-choose-img  z-index">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col first-point-col mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={board} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                A talented and diverse team
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={sandTimer} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Faster Turnaround Time
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row ">
                        <div className="col third-point-col mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={report} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Results You Can Trust
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={infrastructure} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Well-built infrastructure
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}
      <section className="bd-brand-area-two pb-75 pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row second-dedicated-resp">
            <div className="col-xl-4 col-lg-6 col-md-6 third-sec1-responsive">
              <div className="col-12">
                <div className="bd-section-title-wrapper mb-20">
                  <h2 className="bd-section-title mb-0 pl-0 fourth_sec_tittle-dedicat">
                    {" "}
                    Find the perfect{" "}
                    <span style={{ color: "#098FB4" }}>
                      Dedicated Developer
                    </span>{" "}
                    for your business with the right company
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-6 col-md-6 third-sec2-responsive">
              <div className="bd-brand-active-two swiper-container">
                <div className="swiper-wrapper">
                  <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                    If you’re looking to hire a dedicated team of developers to
                    grow your business, it’s worth exploring online platforms or
                    business networks to find the right fit. There are a few key
                    factors to keep in mind. First, ensure you have the right
                    expertise to develop and manage your product effectively.
                    Next, choose developers who are passionate about their work
                    and genuinely committed to the project. Lastly, make sure
                    you’re getting the best value—investing wisely in a team
                    that delivers on their promises is crucial.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth section*/}

      <section className="bd-about-area pb-80">
        <div className="bd-custom-container">
          <div className="bd-about-four-bg pb-0 fix">
            <div className="bd-about-shape-box">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8 fourth_responsive_section1">
                    <div className="bd-about-text bd-about-text-four z-index">
                      <div className="bd-section-title-wrapper">
                        <h2 className="bd-section-title mb-15  md-pr-50 dedicate-last-tittle">
                          We work together as a team to enhance client
                          satisfaction from start to finish.
                        </h2>
                        <p className="">
                          When it comes to getting the right resources for your
                          business, it’s important to choose the best and most
                          effective options. That’s why we’ve put together a
                          dedicated resource just for businesses. Here, you’ll
                          find valuable insights on starting, managing, and
                          growing your business. From expert advice to success
                          stories from entrepreneurs, we’ve got everything you
                          need to kickstart your journey.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 pl-30 fourth_responsive_section2">
                    <div className="bd-about-img">
                      <img
                        // src={workTogether}
                        className="xss-w-full rounded-10"
                        alt="about img not found"
                      />
                      {/* <img className="bd-about-shape bd-about-shape-6 hero-1-dot" src={shape6} alt="shape img not found"/> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                Looking to hire a skilled and dedicated developer?
                </h2>
                <p className="contact_section second-para-resp">
                  You're at the right place. The right time
                </p>
                <p className="contact_subtext">
                An unexpectedly amazing developer let’s get started now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+65 87852030"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +65 87852030
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DedicatedResource;
